// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"2a0c84b0","517":"67276d68","569":"1026661e","787":"e10ea423","810":"cec1c214","888":"ac51cf08"}[chunkId] + ".chunk.js";
};